import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getHomePublicEvent, eventsSetPublicEvents } from 'modules/events/events-actions'
import { Layout, CustomButton, HomePromoRow, BannerMockTicket } from 'components'
import { getSouSouUrl } from 'components/HomePromoRow/souSouUrl'
import Header from './Header'
import Body from './Body'
import './index.styl'

const limit = 20

const Home = () => {
  const [loaded, setLoaded] = useState(false)
  const [loadingPagination, setLoadingPagination] = useState(true)
  const [total, setTotal] = useState(0)
  const [current, setCurrent] = useState(0)
  const [skip, setSkip] = useState(0)
  const dispatch = useDispatch()

  const handleEndFetch = () => {
    setLoaded(true)
    setLoadingPagination(false)
  }

  const handleFetch = obj => {
    dispatch(getHomePublicEvent(obj))
      .then(({ total, current }) => {
        setTotal(total)
        setCurrent(current)
        setSkip(obj.skip)
        handleEndFetch()
      })
      .catch(handleEndFetch)
  }

  useEffect(() => {
    handleFetch({ limit, skip })
    window.dataLayer.push({ event: 'Home' })
    return () => dispatch(eventsSetPublicEvents([]))
  }, [])

  const handleFetchMore = () => {
    setLoadingPagination(true)
    handleFetch({ limit, skip: skip + limit })
  }

  // SOU-22.1: with a valid Sou-Sou URL the dual promo row is the first thing under the header; without it the page is as before
  const hasSouSouPromo = !!getSouSouUrl()

  // const restLength = (total - publicEvents.length)

  return (
    <Layout className='wrapperHome'>
      {hasSouSouPromo && <HomePromoRow />}
      <Header loaded={loaded} />
      <div className='container'>
        <Body loaded={loaded} />
        <div className='fetchMoreContainer'>
          {loaded && current < total && (
            <CustomButton
              disabled={current >= total || loadingPagination}
              loading={loadingPagination}
              onClick={handleFetchMore}
              // text={`Show More ${restLength > limit ? limit : restLength}`}
              text='Show More'
              type='dark'
            />
          )}
        </div>
        {!hasSouSouPromo && <BannerMockTicket />}
      </div>
    </Layout>
  )
}

export default Home
